import React from 'react'
import { connect } from 'react-redux'
import ReactMarkdown from 'components/Markdown/Markdown'
import { getHumanReadableValueByField } from 'utilities'

class Paragraph extends React.PureComponent {
  getMergedFields = (value) => {
    return value.replace(/{{FIELD:(.*?)}}/g, (_, name) => {
      const field = Object.values(this.props.fields).find((f) => f.name === name)
      if (field) {
        return getHumanReadableValueByField(field)
      }
      return ''
    })
  }
  render() {
    const { textAlign, width, value: rawValue, displayType, scrollable, maxHeight } = this.props
    const value = this.getMergedFields(rawValue)
    return displayType === 'input' ? (
      <div
        className={`dummy-text-input ${scrollable ? 'scrollable-paragraph' : ''}`}
        style={{
          width,
          maxHeight: scrollable ? `${maxHeight}px` : '',
        }}
      >
        {value}
      </div>
    ) : (
      <ReactMarkdown
        className={`paragraph markdown ${scrollable ? 'scrollable-paragraph' : ''}`}
        style={{
          textAlign: textAlign,
          width: width,
          maxHeight: scrollable ? `${maxHeight}px` : '',
        }}
        source={value}
      />
    )
  }
}
export default connect((state) => ({
  fields: state.wizard.wizard.fields,
}))(Paragraph)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/Paragraph.js